export default "__VITE_ASSET__B3rUPpww__"